export default "__VITE_ASSET__lN227D8___"